<template>
  <div class="content">
    <div class="container">
      <div class="row">
        <div class="col">
          <card-item
            class="striped-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Parametros locales</h4>
                </div>
              </div>
            </template>

            <div class="container-fluid h-100">
              <div class="row">
                <div v-if="!isLoading" class="col">
                  <form
                    @submit.prevent="submit"
                    v-promise-btn="{ action: 'submit' }"
                    ref="form"
                  >
                    <div class="container">
                      <div class="row">
                        <template v-for="field in fields">
                          <!-- Solo mostrar si NO es el campo id_parametros_locales -->
                          <div
                            v-if="!isIdField(field.Columna)"
                            :key="field.Columna"
                            class="col-12"
                          >
                            <div class="form-group">
                              <label :for="field.Columna" class="label">
                                {{ formatFieldLabel(field.Columna) }}
                              </label>

                              <!-- Campo con formato de moneda -->
                              <vue-numeric
                                v-if="
                                  isMoneyField(field) &&
                                  field.TipoDeDato.toLowerCase() === 'numeric'
                                "
                                :id="field.Columna"
                                v-select-on-focus
                                currency="$"
                                thousand-separator="."
                                decimal-separator=","
                                :precision="Number(field.Escala)"
                                v-model="data[field.Columna.toLowerCase()]"
                                :minus="true"
                                class="col-12 form-control form-control-sm text-center bg-white"
                              />

                              <!-- Campo de porcentaje -->
                              <vue-numeric
                                v-else-if="
                                  isPercentageField(field.Columna) &&
                                  field.TipoDeDato.toLowerCase() === 'numeric'
                                "
                                :id="field.Columna"
                                v-select-on-focus
                                currency="%"
                                currency-symbol-position="suffix"
                                :precision="0"
                                v-model="data[field.Columna.toLowerCase()]"
                                :minus="true"
                                class="col-12 form-control form-control-sm text-center bg-white"
                              />

                              <!-- Campo numérico normal -->
                              <vue-numeric
                                v-else-if="
                                  field.TipoDeDato.toLowerCase() === 'numeric'
                                "
                                :id="field.Columna"
                                v-select-on-focus
                                thousand-separator="."
                                decimal-separator=","
                                :precision="Number(field.Escala)"
                                v-model="data[field.Columna.toLowerCase()]"
                                :minus="true"
                                class="col-12 form-control form-control-sm text-center bg-white"
                              />

                              <!-- Campos regulares -->
                              <input
                                v-else
                                v-select-on-focus
                                :type="getInputType(field.TipoDeDato)"
                                class="form-control text-center"
                                :id="field.Columna"
                                v-model="data[field.Columna.toLowerCase()]"
                              />
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>

                    <div class="w-100 d-flex justify-content-end">
                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="volver"
                      >
                        Cancelar
                      </button>
                      <button type="submit" class="btn btn-primary">
                        Guardar
                      </button>
                    </div>
                  </form>
                </div>
                <div v-else class="col">Cargando...</div>
              </div>
            </div>
          </card-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { get } from "lodash-es";
import VueNumeric from "../../lib/utils/vue-numeric.vue";

export default {
  name: "ParametroLocalesForm",
  components: { VueNumeric },

  data: () => ({
    isLoading: true,
    fields: [],
    data: {},
    columnMapping: {},
  }),

  mounted() {
    this.isLoading = true;
    this.getData().then((data) => {
      if (!data.ok) {
        this.$msgBoxOk(data.message);
      }
      this.isLoading = false;
    });
  },

  methods: {
    isIdField(columnName) {
      return columnName.toLowerCase() === "id_parametros_locales";
    },

    async getData() {
      const resp = await axios.post(`/execute`, {
        method: "SEC.GetParametrosLocales",
        parameters: [],
      });

      if (resp.data.ok) {
        const datos = get(resp.data, "result[0][0]", null);
        this.fields = get(resp.data, "result[1]", []);

        if (datos) {
          this.data = {};
          this.columnMapping = {};
          Object.keys(datos).forEach((key) => {
            const lowerKey = key.toLowerCase();
            const value = datos[key];
            const field = this.fields.find(
              (f) => f.Columna.toLowerCase() === lowerKey,
            );

            if (field && !this.isIdField(field.Columna)) {
              this.columnMapping[lowerKey] = field.Columna;

              if (field.TipoDeDato.toLowerCase() === "numeric") {
                this.$set(this.data, lowerKey, Number(value));
              } else if (field.TipoDeDato.toLowerCase() === "int") {
                this.$set(this.data, lowerKey, Number(value));
              } else {
                this.$set(this.data, lowerKey, value);
              }
            }
          });
        }
      }
      return resp.data;
    },

    getInputType(tipoDato) {
      const tipo = tipoDato.toLowerCase();

      if (tipo.includes("int")) {
        return "text";
      }

      if (tipo === "date") {
        return "date";
      }

      if (tipo.includes("datetime")) {
        return "datetime-local";
      }

      if (tipo === "bit") {
        return "checkbox";
      }

      if (
        tipo.includes("varchar") ||
        tipo.includes("char") ||
        tipo.includes("text")
      ) {
        return "text";
      }

      return "text";
    },

    formatFieldLabel(fieldName) {
      return fieldName
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(" ");
    },

    isMoneyField(column) {
      return (
        column.TipoDeDato === "numeric" &&
        !this.isPercentageField(column.Columna)
      );
    },

    isPercentageField(columnName) {
      return columnName.toLowerCase().includes("porcentaje");
    },

    async volver() {
      await this.getData();
      this.$msgBoxOk("Los cambios han sido descartados", {
        centered: true,
        variant: "info",
      });
    },

    async submit() {
      if (!this.isValidForm()) {
        this.$msgBoxOk("Por favor, complete todos los campos requeridos", {
          centered: true,
        });
        return;
      }

      try {
        const dataToSend = {};
        Object.entries(this.data).forEach(([key, value]) => {
          const originalColumnName = this.columnMapping[key];
          if (originalColumnName && !this.isIdField(originalColumnName)) {
            if (typeof value === "number" || !isNaN(value)) {
              const numericValue = value.toString().replace(/[^0-9.-]/g, "");
              dataToSend[originalColumnName] = numericValue;
            } else {
              dataToSend[originalColumnName] = value.toString();
            }
          }
        });

        const parameters = [
          {
            name: "json",
            value: JSON.stringify(dataToSend),
          },
          {
            name: "executeUpdate",
            value: 1,
          },
        ];

        const resp = await axios.post(`/execute`, {
          method: "SEC.ModificarParametrosLocales",
          parameters: parameters,
        });

        if (resp.data.ok) {
          this.$msgBoxOk(`Query ejecutada : ${resp.data.result[0][0].sql}`, {
            title: "Parámetros actualizados correctamente",
            centered: true,
          });
        } else {
          this.$msgBoxOk(` ${resp.data.message}`, {
            title: "Ha ocurrido un error",
            centered: true,
          });
        }
      } catch (error) {
        console.error("Error completo:", error);
        this.$msgBoxOk({
          title: "Error al guardar los parámetros",
          centered: true,
        });
      }
    },

    isValidForm() {
      return Object.values(this.data).every(
        (value) => value !== null && String(value).trim() !== "",
      );
    },
  },
};
</script>

<style scoped></style>
